import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String }

  keydown(event) {
    if (event.key === "Delete" || event.key === "Backspace") {
      event.preventDefault()
      this.startDelete()
    }
  }

  clickDelete(event) {
    event.preventDefault()
    this.startDelete()
  }

  startDelete() {
    if (this._pending) return

    const card = this.element
    const title = this.titleValue || "Clip"
    this._originalHTML = card.innerHTML
    this._pending = true

    card.innerHTML = `
      <div class="flex items-center justify-between px-4 py-3">
        <span class="text-sm text-[var(--color-mc-text-secondary)]">
          <span class="font-medium text-[var(--color-mc-text)]">${this.escapeHtml(title)}</span> deleted
        </span>
        <button data-action="clip-delete#undo" class="text-sm font-medium text-[var(--color-mc-accent-terracotta)] hover:underline">
          Undo
        </button>
      </div>
      <div class="h-0.5 bg-[var(--color-mc-accent-terracotta)]/20">
        <div class="h-full bg-[var(--color-mc-accent-terracotta)] transition-all duration-[5000ms] ease-linear" style="width: 100%;" data-clip-delete-target="timer"></div>
      </div>
    `

    // Start the countdown bar animation
    requestAnimationFrame(() => {
      const bar = card.querySelector("[data-clip-delete-target='timer']")
      if (bar) bar.style.width = "0%"
    })

    this._timeout = setTimeout(() => this.confirmDelete(), 5000)
  }

  undo() {
    if (this._timeout) clearTimeout(this._timeout)
    this.element.innerHTML = this._originalHTML
    this._pending = false
  }

  async confirmDelete() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "text/html"
        }
      })
      if (response.ok || response.redirected) {
        this.element.remove()
      } else {
        this.undo()
      }
    } catch {
      this.undo()
    }
  }

  disconnect() {
    if (this._timeout) clearTimeout(this._timeout)
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
